import React from "react";
import "../App.scss";
import { Table, Button } from "react-bootstrap";

class BasicGrid extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.table = this.table.bind(this);
    this.state = { a: "" };
  }

  tableHeader = (columnProps: any) => {
    const rowColumns =
      columnProps &&
      columnProps.map((it: any) => {
        return <th>{it.label}</th>;
      });

    return (
      <thead>
        <tr>{rowColumns}</tr>
      </thead>
    );
  };

  tableBodyRow = (dataItem: any, columnProps: any) => {
    const rowColumns =
      columnProps &&
      columnProps.map((it: any) => {
        if (it.callback) {
          return (
            <td>
              {" "}
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() =>
                  it.callback(
                    this.props.that,
                    this.props.componentRef,
                    it.attr,
                    dataItem
                  )
                }
              >
                {it.label}
              </Button>
            </td>
          );
        }
        var columnValue;
        if (it.attr.includes(".")) {
          let nestedFields = it.attr.split(".");
          var current = dataItem[nestedFields[0]];
          let nestLevel = nestedFields.length;
          for (let i = 1; i < nestLevel; ++i) {
            if (Array.isArray(current)) {
              let temp = [];
              for (let k = 0; k < current.length; ++k) {
              let tt = current[k][nestedFields[nestLevel - 1]];
              temp.push(tt);
              }
              columnValue = temp.join();
            } else {
              current = current[nestedFields[i]];
              columnValue = current;
            }
          }
        } 
        else {
          columnValue = dataItem[it.attr];
        }
        return <td>{columnValue}</td>;
      });

    return <tr>{rowColumns}</tr>;
  };

  tableBody = (data: any, columnProps: any) => {
    const rows =
      data &&
      data.map((it: any) => {
        return this.tableBodyRow(it, columnProps);
      });

    return <tbody>{rows}</tbody>;
  };

  table = (data: any, columnProps: any) => {
    return (
      <Table striped bordered hover>
        {this.tableHeader(columnProps)}
        {this.tableBody(data, columnProps)}
      </Table>
    );
  };

  render() {
    let { data, columnProps } = this.props;
    const grid = this.table(data, columnProps);
    return <div className={this.props.className}>{grid}</div>;
  }
}

export default BasicGrid;
